import { enableProdMode, provideZoneChangeDetection } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { setCurrentTheme, Theme } from '@ip-only/front-end-library';
import 'leaflet';
import 'leaflet.markercluster';
import 'zone.js';
import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

if (environment.productionBuild) {
  enableProdMode();
}

setCurrentTheme(Theme.GC_LIGHT);

platformBrowserDynamic()
  .bootstrapModule(AppModule, {
    applicationProviders: [provideZoneChangeDetection()],
  })
  .catch((err) => console.error(err));
